import QuotaExceeded from './QuotaExceededModal.container'

export default QuotaExceeded
